export default __webpack_public_path__ + "static/media/water-main-meter-icon.b95489f0.svg";